module.exports = __webpack_public_path__ + "static/media/CeraPro-Italic.93bd419a.woff";